<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row page__row_between">
        <div class="page__item">
          <h1 class="title">Графики работы</h1>
        </div>
        <div class="page__item">
          <AppButtonSmAdd title="Создать" @click.native="showCreateModal" />
        </div>
      </div>
    </section>

    <section class="section page__content">
      <div class="page__row mb-20" v-if="schedules.length !== 0">
        <AppTable :data="schedules"
                  :headers="tableHeaders"
                  :isMenuControlsActive="roleAccessRemove"
                  @show-this-item="showUpdateModal"
                  @toggle-controls="showRemoveConfirmation"
        />
      </div>
      <div class="page__row mb-20" v-else>
        <div class="no-records">
          <AppNoRecordsPlaceholder text="В разделе еще нет ни одной записи"/>
        </div>
      </div>
    </section>

    <section class="section page__footer directory-list__footer">
      <div class="page__row">
        <!--место для пагинации-->
      </div>
    </section>

    <transition-group name="fade">
      <AppConfirmation v-if="removeConfirmation.active"
                       key="remove-confirmation"
                       text="Вы действительно хотите удалить этот график?"
                       @confirm="removeItem"
                       @reject="closeModals"
      />
      <ItemUpdateModal v-if="updateModal.active"
                       key="update-modal"
                       title="Редактировать график работы"
                       :item="updateModal.schedule"
                       :name-validation="updateModal.validation"
                       @set-item-name="setItemUpdatedName"
                       @update-item="updateItem"
                       @close-modal="closeModals"
      />
      <ItemCreateModal v-if="createModal.active"
                       key="create-modal"
                       title="Создать вид график работы"
                       :value="createModal.newScheduleName"
                       :name-validation="createModal.validation"
                       @set-item-name="setNewItemName"
                       @create-item="createItem"
                       @close-modal="closeModals"
      />
    </transition-group>
    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>
import AppTable from '../../../components/page/table/AppTable'
import AppConfirmation from '../../../components/page/modal/AppConfirmation'
import AppButtonSmAdd from '../../../components/page/button/AppButtonSmAdd'
import ThePagePreloader from '../../../components/page/ThePagePreloader'
import ItemUpdateModal from '../../../components/page/modal/itemUpdateModal'
import ItemCreateModal from '../../../components/page/modal/itemCreateModal'
import AppNoRecordsPlaceholder from '../../../components/page/text/AppNoRecordsPlaceholder'

export default {
  name: 'SchedulesList',
  components: {
    AppNoRecordsPlaceholder,
    ItemCreateModal,
    ItemUpdateModal,
    ThePagePreloader,
    AppButtonSmAdd,
    AppConfirmation,
    AppTable
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        id: null
      }
    }
  },
  computed: {
    schedules () {
      const schedules = this.$store.getters.schedules
      const schedulesData = []
      for (let i = 0; i < schedules.length; ++i) {
        schedulesData.push({
          id: schedules[i].id,
          isControlsActive: schedules[i].isControlsActive,
          values: [
            schedules[i].name
          ]
        })
      }
      return schedulesData
    },
    isLoading () {
      return this.$store.getters.scheduleListIsLoading
    },
    tableHeaders () {
      return this.$store.getters.scheduleListTableHeaders
    },
    updateModal () {
      return this.$store.getters.scheduleListUpdateModal
    },
    createModal () {
      return this.$store.getters.scheduleListCreateModal
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightContracts.actions.remove
    }
  },
  methods: {
    toggleItemControls (itemId) {
      this.$store.dispatch('toggleScheduleListItemControls', itemId)
    },
    showCreateModal () {
      this.$store.dispatch('showScheduleListCreateModal')
    },
    setNewItemName (name) {
      this.$store.dispatch('setCreatedScheduleName', name)
      this.$store.dispatch('clearScheduleListModalValidation')
    },
    createItem () {
      this.$store.dispatch('createSchedule')
    },
    showUpdateModal (itemId) {
      this.$store.dispatch('showScheduleListUpdateModal', itemId)
    },
    setItemUpdatedName (name) {
      this.$store.dispatch('setUpdatedScheduleName', name)
      this.$store.dispatch('clearScheduleListModalValidation')
    },
    updateItem () {
      this.$store.dispatch('updateSchedule')
    },
    showRemoveConfirmation (itemId) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = itemId
    },
    removeItem () {
      this.$store.dispatch('deleteSchedule', this.removeConfirmation.id)
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    closeModals () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
      this.$store.dispatch('closeScheduleListModals')
      this.$store.dispatch('clearScheduleListModalValidation')
    }
  },
  mounted () {
    this.$store.dispatch('getSchedules')
  }
}
</script>

<style lang="scss" scoped>
.directory-list {
  &__footer {
    padding-bottom: 110px;
  }
}

.no-records {
  width: 100%;
  margin-top: 80px;
}
</style>
